// extracted by mini-css-extract-plugin
module.exports = {"searchFeedback":"kR"};